import React from 'react';
import AppLayout from './components/app/layout/AppLayout.tsx';

export function App() {
    return <AppLayout/>;
}

